module.exports = __webpack_public_path__ + "static/media/svg-3.2d76b633.svg";